<div class="cc-top pb-5 mt-5" *ngIf="decisions">
    <!-- Splash image of the institution. -->
    <div class="tipper-image">
        <img alt="Celebrate Good News" src="../../../../assets/splash/success.png" />
    </div>
    <h2 class="h1 w-100 text-center fw-bold mb-5">Review And Share</h2>
        
    <p class="text-center col-md-8 col-sm-12 mx-auto">Awesome! You've made significant progress on deciding on a career path. 
        
    <!-- <strong class="tipper-row">Coursera</strong> is ready to help you through the next phase. Learn more about their <strong class="tipper-row">{{decisions[0]?.selectedOption?.title}}</strong> program today.</p>

    <div class="col mx-auto text-center">
        <a class="btn btn-primary mt-3" href="http://www.coursera.com" target="_blank">Learn More</a>
    </div> -->
</div>
<!-- THIS IS FOR ERROR STATE -->
<div class="row cc-top text-center pd-5 mt-5" *ngIf="errorState">
    <div class="tipper-image">
        <img alt="Not Able To Locate" src="../../../../assets/splash/oops.png" />
    </div>
    <h2>Ooops... Resource Not Found</h2>
    <p class="text-danger mb-5">Unable to locate the details you've requested. Please update your link.</p>
    <a class="btn btn-primary mx-auto mb-5" [routerLink]="[ urlPath.WELCOME ]">Home</a>
</div>

<div class="flex-item card path-summary-content cc-content container" *ngIf="!errorState && traversedPaths.length > 0">
    <!-- The advertising details about the organisation.-->
    <div class="card-body mt-5 mb-5 text-center">
        <h1 class="h6 w-100 text-center text-uppercase fw-bold mb-4">Your Summary</h1>
        <h2 class="h1 fw-bold">{{selectedCareerChoice?.title || 'Test Title' }}</h2>
        <div  class="custom-separator .my-4 mx-auto bg-primary"></div>
        <p class="pt-3">Here are the list of paths you've choosen.</p>
    </div>

    <!-- This is if data was found. -->
    <div class="mb-5 cc-wrapper-container d-flex flex-md-column flex-md-no-wrap overflow-auto pe-3">
        <div class="flex-shrink-0 d-flex flex-md-column me-md-3 mb-2 mb-md-0 gap-3 gap-md-3 mb-md-5">
            <div id="summary-{{rung?.id}}" 
                class="modal-content mb-3" 
                *ngFor="let rung of traversedPaths | reverse; let indexOfElement=index;"
                (click)="toggle(rung?.id)"
                [attr.aria-expanded]="activeId === rung?.id">
            
                <div class="my-3 p-3 border-0"
                    [ngClass]="indexOfElement > 0? 'not-first': '' ">
                    <!-- Details -->
                    <div class="top-content border-0 border-light">
                        <div class="row intro-summary">
                            <h2 class="col h1 w-100 text-center fw-bold mb-5">{{rung?.label || 'Undefined Title'}}</h2>
                        </div>
                        <div id="color-indicator-wrapper" class="tool-tip p-0 justify-content-center"
                            ngbTooltip="General description about this career path" 
                            [autoClose]="true" 
                            triggers="click">                
                                <span
                                class="d-flex mx-auto rounded-5"
                                [style.background]="rung.color">&nbsp;</span>
                        </div>
                    </div>
                    
                    <!-- collapsed content | MOBILE -->
                    <div class="d-none d-sm-block">
                        <div class="additional-content collapse" 
                            id="collapsable-{{rung?.id}}" 
                            #collapse="ngbCollapse"
                            [ngbCollapse]="activeId !== rung?.id"
                            >
                            <div class="card border-0">
                                <div class="card-body border-0">
                                    <app-step-details 
                                        [init]="true"
                                        [visible]="true"
                                        [previewMode]="true"
                                        [steps]="rung?.steps" >
                                    </app-step-details>
                                    <!-- <div class="col col-sm-12" *ngFor="let track of rung.steps">
                                        <h6>{{track.title}}</h6>
                                        <p>{{track.objective}}</p>

                                        <ul class="path-summary-step-details">
                                            <li *ngFor="let item of track.list">
                                                <ng-container *ngIf="item.enable == true">
                                                    <p>&#8250; {{item.subject}}</p>
                                                </ng-container>
                                            </li>
                                        </ul>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- COllapse content | NON-MOBILE -->
                    <div class="d-block d-sm-none">
                        <!-- SETUP TO SCROLLSPY  -->

                    </div>
            </div> 
            </div>
        </div>
    </div>

    <!-- IF nothing was found -->
    <div class="cc-summary-last-survey mb-5">
        <div class="quick-feedback-wrapper text-center" *ngIf="!feedbackSubmitted">
            <h6>Was this helpful?</h6>
            <div class="mx-auto mt-3">
                <!-- <a class="btn btn-secondary mr-2 ml-2"  (click)="feedback('No')">Feedback</a> -->
                <a class="btn btn-primary shadow rounded-3  ml-2" (click)="feedback('Yes')">Share Feedback</a>
            </div>
        </div>
        <div class="quick-feedback-wrapper text-center" *ngIf="feedbackSubmitted">
            <p class="text-success pt-3">Thank you for your feedback.</p>
        </div>
    </div>

    <div class="row cc-footer">  
    
        <button class="col col-5 btn btn-secondary" 
        (click)="restart()">Restart</button> 
        <span class="col col-2">&nbsp;</span>   

        <button *ngIf="menuOptions?.length == 1 ?? false"
            class="col col-5 btn btn-primary px-0" 
            (click)="makeDecision(menuOptions[0])">{{menuOptions[0]?.title}} 
        
            <span class="badge">
                <img [src]="menuOptions[0]?.logo"/>
            </span>
        </button>

        <div ngbDropdown 
            #menuDropdown="ngbDropdown" 
            class="col col-5 additional-menu px-0" 
            placement="top-right bottom-rigt"
            *ngIf="menuOptions && menuOptions.length > 1">
            
            <button ngbDropdownAnchor 
                class="btn btn-primary" 
                id="menuOptions" 
                (click)="menuDropdown.open()">{{selectedMenuOption != undefined ? selectedMenuOption?.title : 'Share' }}</button>
            
            <div ngbDropdownMenu 
                arial-labelledby="menuOptions">            
                
                <button class="dropdown-item"
                    *ngFor="let choice of (menuOptions ?? [])" 
                    (click)="makeDecision(choice)">
                    <span *ngIf="choice?.logo" class="badge"><img  [src]="choice?.logo" alt="Logo for {{choice?.title}}" /></span>
                    {{choice?.title}}</button>
            </div>
        </div>
    </div>
</div>

<div class="alert-wrapper" *ngIf="showAlert">
    <ngb-alert #summaryAlert type="success" (close)="closeAlert()">{{alertMessage ?? ''}}</ngb-alert>
</div>

